import useAxios from '../../utils/useAxios'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const getProjects = createAsyncThunk('projects/get', async (...args) => {
  try {
    const axios = useAxios()
    const { data } = await axios.get('/api/projects/all')
    return data
  } catch (error) {
    const { rejectWithValue } = args[1]
    // return custom error message from API if any
    if (error.response && error.response.data.detail) {
      return rejectWithValue(error.response.data.detail)
    } else {
      return rejectWithValue(error.message)
    }
  }
})

export const saveProject = createAsyncThunk(
  'project/save',
  async (project, { rejectWithValue }) => {
    try {
      const axios = useAxios()
      const { data } = await axios.put(`/api/projects/${project.id}/`, project)
      return data
    } catch (error) {
      // return custom error message from API if any
      console.log(error)
      if (error.response && error.response.data.detail) {
        return rejectWithValue(error.response.data.detail)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

export const createProject = createAsyncThunk(
  'project/create',
  async (project, { rejectWithValue }) => {
    try {
      const axios = useAxios()
      const { data } = await axios.post('/api/projects/', project)
      return data
    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.detail) {
        return rejectWithValue(error.response.data.detail)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

export const deleteProject = createAsyncThunk(
  'project/delete',
  async (project, { rejectWithValue }) => {
    try {
      const axios = useAxios()
      const { data } = await axios.delete(`/api/projects/${project.id}/`)
      return data
    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.detail) {
        return rejectWithValue(error.response.data.detail)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)
